/**
 * Picks which document tab a user should land on when the Audit Process page
 * first loads, so their own actionable work is immediately visible instead
 * of requiring a manual tab click + scroll past the stepper and
 * Mandays/EA Code/Scope cards every time.
 *
 * Before this, activeDocTab always hardcoded to 'sales-pack' regardless of
 * role -- an Application Reviewer (or any other role) had to find and click
 * their own tab manually on every visit.
 *
 * Deliberately role -> tab, not task -> tab: a user can hold more than one
 * role on a project (e.g. admin), so this picks the single most specific/
 * actionable one via priority order, falling back to the existing default
 * ('sales-pack', still relevant to most roles) for anyone without one
 * specific actionable tab (admin/manager, sales-only, no assignment yet).
 */
const ROLE_TO_TAB_PRIORITY = [
  ['isApplicationReviewer', 'checklist-verification'],
  ['isScheduler', 'scheduling'],
  ['isAuditor', 'audit'],
  ['isTechnicalReviewer', 'technical-review'],
  ['isCertificationAuthority', 'certificate'],
  ['isCertificationIssuer', 'certificate'],
];

export const DEFAULT_DOC_TAB = 'sales-pack';

export const resolvePrimaryDocTab = (myProjectRole, visibleDocTabIds) => {
  const visible = new Set(Array.isArray(visibleDocTabIds) ? visibleDocTabIds : []);
  const role = myProjectRole || {};

  // Admin/manager see everything and have no single task of their own --
  // keep them on the existing default rather than guessing one tab for them.
  if (role.isAdminOrManager) return DEFAULT_DOC_TAB;

  for (const [roleFlag, tabId] of ROLE_TO_TAB_PRIORITY) {
    if (role[roleFlag] && visible.has(tabId)) {
      return tabId;
    }
  }

  return DEFAULT_DOC_TAB;
};
